import { render, staticRenderFns } from "./MySkills.vue?vue&type=template&id=92ae1648&scoped=true&"
import script from "./MySkills.vue?vue&type=script&lang=js&"
export * from "./MySkills.vue?vue&type=script&lang=js&"
import style0 from "./MySkills.vue?vue&type=style&index=0&id=92ae1648&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ae1648",
  null
  
)

export default component.exports